import dayjs from 'dayjs'
import { ScaleReading } from '../../types/Dashboards'

export const mapBodyCompScaleReadingsToTableRows = (readings: ScaleReading[], isMobile: boolean) => {
  if (readings) {
    return readings.map((reading, index) => ({
      id: index,
      readingId: `${reading.patientReadingPId}`,
      readingDate: `${dayjs(reading.readingDate).format('M/DD/YYYY')}`,
      readingTime: `${dayjs(reading.readingDate).format('h:mm a')}`,
      weight: `${reading.value}`,
      change: `${reading.change}`,
      bodyFatPercent: `${reading.bodyFatPercent ?? ''}`,
      musclePercent: `${reading.musclePercent ?? ''}`,
      waterPercent: `${reading.waterPercent ?? ''}`,
      visceralFat: `${reading.visceralFat ?? ''}`,
      vascularAge: `${reading.vascularAge ?? ''}`,
    }))
  }
}
